import { useTranslation } from "react-i18next";

export function ReportViewerSummaryList() {
  const [translate] = useTranslation(["insights"]);
  const items = [
    [translate("report-viewer-summary-list-item-1")],
    [translate("report-viewer-summary-list-item-2")],
    [translate("report-viewer-summary-list-item-3")],
    [translate("report-viewer-summary-list-item-4")],
    [translate("report-viewer-summary-list-item-5")],
    [translate("report-viewer-summary-list-item-6")],
    [translate("report-viewer-summary-list-item-7")],
  ] as const;

  return (
    <div>
      <h3 className="text-xl font-semibold mb-4">
        {translate("report-viewer-summary-list-title")}
      </h3>
      <div className="grid grid-cols-1 gap-4 text-sm">
        {items.map(([label]) => (
          <div key={label} className="flex justify-between">
            <span>{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
